var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGpoxcIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0L22.183 22.183L15.5281 28.838L0 13.3098V0Z",
    fill: "#48C1F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3663 0L22.1832 22.183L15.5283 15.5281L31.0564 0H44.3663Z",
    fill: "#8800BA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3666 44.3663L22.1836 22.1832L28.8385 15.5283L44.3666 31.0564V44.3663Z",
    fill: "#FF6C0D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 44.3661L22.183 22.1831L28.8379 28.838L13.3098 44.3661H0Z",
    fill: "#A6CA3A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3666 0L22.1836 22.183L28.8385 28.838L44.3666 13.3098V0Z",
    fill: "#E30083"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0L22.183 22.183L28.8379 15.5281L13.3098 0H0Z",
    fill: "#214386"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 44.3663L22.183 22.1832L15.5281 15.5283L0 31.0564V44.3663Z",
    fill: "#009335"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3663 44.3661L22.1832 22.1831L15.5283 28.838L31.0564 44.3661H44.3663Z",
    fill: "#FFBF00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGpoxcIcon);
export default __webpack_public_path__ + "static/media/gpoxc-icon.c7fe57c942ea349226ff4e53c53cdc4a.svg";
export { ForwardRef as ReactComponent };